import React, { useEffect, useState } from 'react';
import { CheckCircle2, Loader2, Sparkles } from 'lucide-react';
import { Progress } from './ui/progress';

const DEFAULT_STAGES = [
  'Reading your business signals',
  'Mapping friction to practical AI use cases',
  'Checking tool stack and integration readiness',
  'Estimating manual-work cost and recoverable value',
  'Selecting a responsible first pilot',
  'Preparing your diagnostic report'
];

export const ReportGenerationProgress = ({ companyName = 'your business', stages = DEFAULT_STAGES }) => {
  const [activeStage, setActiveStage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStage(current => Math.min(current + 1, stages.length - 1));
    }, 1400);
    return () => clearInterval(interval);
  }, [stages.length]);

  const percent = Math.round(((activeStage + 1) / stages.length) * 100);

  return (
    <div className="w-full max-w-2xl mx-auto bg-white rounded-xl shadow-lg border border-primary/10 p-6 space-y-5">
      <div className="flex items-center justify-center gap-3 text-primary">
        <div className="relative">
          <Sparkles className="h-8 w-8" />
          <Loader2 className="h-4 w-4 animate-spin absolute -right-2 -top-2" />
        </div>
        <div className="text-left">
          <h2 className="text-2xl font-bold">Building your Responsible AI Diagnostic</h2>
          <p className="text-sm text-muted-foreground">Analyzing {companyName}</p>
        </div>
      </div>

      <Progress value={percent} className="h-3" />
      <div className="space-y-3 text-left">
        {stages.map((stage, index) => {
          const complete = index < activeStage;
          const active = index === activeStage;
          return (
            <div key={stage} className={`flex items-center gap-3 rounded-lg p-3 ${active ? 'bg-primary/10 text-primary' : complete ? 'bg-accent/10 text-secondary' : 'bg-muted/40 text-muted-foreground'}`}>
              {complete ? <CheckCircle2 className="h-5 w-5" /> : active ? <Loader2 className="h-5 w-5 animate-spin" /> : <div className="h-5 w-5 rounded-full border border-current" />}
              <span className="text-sm font-medium">{stage}</span>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground text-center">
        We are using your answers to choose a practical first pilot, not promising guaranteed savings.
      </p>
    </div>
  );
};
